import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
  })
  
export class PublicFunctions {
    public substringTitle(text, len) {
    
        var subS = Array<any>();
        var str1;
        for (let index = 0; index < text.length; index++) {
          const element = text[index];
          //console.log(element);
          str1 = element.substr(len, element.length)
          subS.push(str1);
         // console.log(str1);
        }
        
            return subS;
    }

    //dung de bo 20 ky tu ngay thang nam gio phut giay truoc ten file dinh kem
    public substringFile(text, len) {
		var subS;
		if (text.length > (len)) {                             
			subS = text.substr(len, text.length);

		}
		else {
			subS = text;
		}
		return subS;
  }

  public substringText(text, len) {
		var subS;
		if (text.length > (len)) {                             
								  
			text += ' ';
      var le = text.indexOf(' ', len);
      
			if (text.length <= le) {
				 subS = text;
			}
			else {
			//console.log(text.substr(0, le));
				subS = text.substr(0, le) + "...";
			}                              

		}
		else {
			subS = text;
		}
		return subS;
  }
  

  public isNumber(n) { 
    return /^-?[\d.]+(?:e-?\d+)?$/.test(n); 
    }

  public  getWeekNumber(d) {
      // Copy date so don't modify original
      d = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
      // Set to nearest Thursday: current date + 4 - current day number
      // Make Sunday's day number 7
      d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay()||7));
      // Get first day of year
      var yearStart : any;
      yearStart = new Date(Date.UTC(d.getUTCFullYear(),0,1));
      // Calculate full weeks to nearest Thursday
      var weekNo = Math.ceil(( ( (d - yearStart) / 86400000) + 1)/7);
      // Return array of year and week number
      return [d.getUTCFullYear(), weekNo];
   }

   public startOfWeek(d) {
    var beg = new Date(d);
    beg.setDate(beg.getDate() - beg.getDay() + 1);
    beg.setHours(0);
    beg.setMinutes(0);
    beg.setSeconds(0);
    return beg;
  }
  
  //Given a date, returns a new date object that contains the end of the week
  public endOfWeek(d) {
    var end = this.startOfWeek(d);
    end.setDate(end.getDate() + 6);
    return end;
  }


}